<template>
  <p v-if="spec.html" class="form-control-static" v-html="value"></p>
  <p v-else class="form-control-static">{{value}}</p>
</template>

<script>
  import mixin from './mixin';

  export default {
    name: 'f-label',
    mixins: [mixin],
  };
</script>



// WEBPACK FOOTER //
// f-label.vue?517e700f